import { SideBarElementsType } from "@/common/types";
import {
  CompaniesIcon,
  SettingsIcon,
  UserIcon,
  VendorIcon,
} from "@/components/icon";

const accountElements: SideBarElementsType[] = [
  {
    icon: <CompaniesIcon />,
    label: "Customers",
    to: "customers",
  },
  {
    icon: <VendorIcon />,
    label: "Vendors",
    to: "vendors",
  },
  {
    icon: <UserIcon />,
    label: "AIRX Users",
    to: "airx-users",
  },
  {
    icon: <SettingsIcon />,
    label: "Roles & Permissions",
    to: "roles-permissions",
  },
];
export default accountElements;
